var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageSubmenu',{attrs:{"links":_vm.links}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }